var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 8,
    viewBox: "0 0 28 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H10.4L14 4.5L10.4 8H0L4 4.5L0 0Z",
    fill: "#817D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H24.4L28 4.5L24.4 8H14L18 4.5L14 0Z",
    fill: "#817D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevron);
export default __webpack_public_path__ + "static/media/double-chevron.73781c3a2a117a68e55e3527b682e4b0.svg";
export { ForwardRef as ReactComponent };